var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.01,
    height: 13.573,
    viewBox: "0 0 20.01 13.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-896.258 -504.677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(896.508 504.927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.636,10.851H7a.367.367,0,1,1,0-.734H11.27V.734H.734v9.384H3.081a.367.367,0,1,1,0,.734H.367A.367.367,0,0,1,0,10.484V.367A.367.367,0,0,1,.367,0h11.27A.367.367,0,0,1,12,.367V10.484a.367.367,0,0,1-.367.367",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.769,19.859a.361.361,0,0,1-.329-.212l-2.022-4.5h-3.236a.358.358,0,1,1,0-.715h3.47a.36.36,0,0,1,.329.212l2.117,4.716a.358.358,0,0,1-.328.5",
    transform: "translate(-101.557 -12.987)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.224,102.059h-1.992a.367.367,0,0,1,0-.734h1.992a.367.367,0,0,1,0,.734",
    transform: "translate(-101.596 -91.208)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.356,88.665A2.344,2.344,0,1,1,31.7,86.321a2.347,2.347,0,0,1-2.344,2.344m0-3.954a1.61,1.61,0,1,0,1.61,1.61,1.612,1.612,0,0,0-1.61-1.61",
    transform: "translate(-24.315 -75.592)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,88.665a2.344,2.344,0,1,1,2.344-2.344A2.347,2.347,0,0,1,135,88.665m0-3.954a1.61,1.61,0,1,0,1.61,1.61,1.612,1.612,0,0,0-1.61-1.61",
    transform: "translate(-119.407 -75.592)",
    stroke: "#000",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2234.04-6958.695h1.529v-4.8h-2.049",
    transform: "translate(-1320 7474.821)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.a02a3becb9c7d931e6ed304f4210f9d6.svg";
export { ForwardRef as ReactComponent };